"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatCharge = formatCharge;
function formatCharge(charge) {
    if (charge === 1)
        return '+';
    if (charge > 1)
        return `+${charge}`;
    if (charge < 0)
        return String(charge);
    return '';
}
//# sourceMappingURL=formatCharge.js.map